export default "__VITE_ASSET__COZO1nwu__";